import { extractInvokePreviewAction } from '../../action/extract-invoke-preview-action';
export var extractPreviewClientAction = function extractPreviewClientAction(param) {
  var result = extractInvokePreviewAction(param);
  return result ? result : undefined;
};